module.exports = __webpack_public_path__ + "static/media/css-grid.5d188bd4.jpg";